import { useEffect, useState } from 'react'
import { account } from '../../../../../classes/Account'
import { formatPhoneNumber, refreshAccessToken } from '../../../../../utilities/extensions'
import { apiURL } from '../../../../../utilities/URLs'
import { Agent } from '../../classes/Agent'
import { useNavigate } from 'react-router-dom'

export default function DashboardAgentTile({ applicationId, stageId }) {
  const navigate = useNavigate()
  const [agent, setAgent] = useState(new Agent())

  useEffect(() => {
    const handleGetAgent = async () => {
      const agentResponse = await fetch(`${apiURL}/api/applications/${applicationId}/agent/`, {
        method: 'GET',
        headers: {
          'Authorization': account.accessToken
        }
      })
      const agentData = await agentResponse.json()
      if (agentData.response.error) {
        if (agentData.response.error === 'Failed To Authenticate Token.') {
          const refreshedToken = await refreshAccessToken()
          refreshedToken && refreshedToken.length > 0 ? await handleGetAgent() : navigate('/', { state: { expired: true } })
        } else
          console.error(agentData.response.error)
      } else
        setAgent(new Agent(agentData.response.agent))
    }

    handleGetAgent()
  }, [applicationId, navigate])

  return (
    <div className='w-full lg:w-1/3 p-6 rounded-2xl bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 shadow-sm flex flex-col gap-4 transition-colors duration-300'>
      <p className='font-bold text-lg sm:text-xl text-slate-800 dark:text-white'>Your Agent Information</p>
      {agent.agentId ? (
        <div className='w-full flex flex-col gap-4 text-sm sm:text-base'>
          <div className='w-full flex flex-row items-center justify-between'>
            <p className='font-bold text-slate-600 dark:text-slate-300'>Name:</p>
            <p className='text-slate-800 dark:text-gray-100'>{agent.name}</p>
          </div>
          <div className='w-full flex flex-row items-center justify-between'>
            <p className='font-bold text-slate-600 dark:text-slate-300'>Email:</p>
            <a href={`mailto:${agent.email}`} className='text-ertc-primary hover:underline cursor-pointer'>{agent.email}</a>
          </div>
          <div className='w-full flex flex-row items-center justify-between'>
            <p className='font-bold text-slate-600 dark:text-slate-300'>Phone:</p>
            <a href={`tel:${agent.phone}`} className='text-ertc-primary hover:underline cursor-pointer'>{formatPhoneNumber(agent.phone)}</a>
          </div>
          {(stageId !== '99386a1c-cce3-4077-bc9d-c18cf0b3fe82' && stageId !== '30b33591-0020-4f17-b9ee-8b461360dc67') && (
            <div className='w-full flex flex-col mt-2 items-center gap-2'>
              <button onClick={() => window.location.href = agent.calenderURL} className='w-full sm:w-3/4 py-2 rounded-xl bg-ertc-primary text-white font-bold transition-transform active:scale-95'>
                Book a Meeting
              </button>
            </div>
          )}
        </div>
      ) : (
        <p className='italic text-slate-400 dark:text-slate-500'>An agent will be assigned to you shortly.</p>
      )}
    </div>
  )
}